/**
 * Get the logarithm of x with base 10.
 *
 * @param {number} x
 */
export function log10(x) {
  return Math.log(x) / Math.log(10);
}

export { delta as substract } from './PositionUtil';
